import { render, staticRenderFns } from "./CoachRegisterExplanation.vue?vue&type=template&id=06c6af98&scoped=true&"
import script from "./CoachRegisterExplanation.vue?vue&type=script&lang=js&"
export * from "./CoachRegisterExplanation.vue?vue&type=script&lang=js&"
import style0 from "./CoachRegisterExplanation.vue?vue&type=style&index=0&id=06c6af98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c6af98",
  null
  
)

export default component.exports